<!------------------------------------------- template ------------------------------------------->
<template>
  <div class="page">
    <!--  顶部banner  -->
    <div class="banner container">
      <div class="banner1"></div>
    </div>
    <!--  市场智能硬件/商铺智能硬件切换  -->
    <!-- <div class="menu_box">
      <div
        class="menu_con"
        :class="{ active_menu: item.id === active }"
        v-for="item in menuList"
        :key="item.index"
        @click="chooseMenu(item)"
      >
        {{ item.title }}
      </div>
    </div> -->
    <!--  市场智能硬件  -->
    <div v-if="active === 1">
      <div v-for="item in marketList" :key="item.id" :class="{ bg_blue: item.bgBlue }">
        <div class="hard_box">
          <div class="hard_img" v-if="!item.bgBlue">
            <img :src="item.image" alt="" />
            <span :class="{ title_white: item.title === '智能PDA' }">{{ item.title }}</span>
          </div>
          <div class="hard_con_box" :class="{ hard_con_box_right: item.bgBlue }">
            <div
              v-for="(innerItem, index) in item.list"
              :key="index"
              class="hard_content_box"
              :class="{
                con_white: item.bgBlue,
                content_7: item.list.length == 7,
                content_8: item.list.length == 8
              }"
            >
              <div class="hard_inner_img"><img :src="innerItem.image" alt="" /></div>
              <div class="hard_title">{{ innerItem.title }}</div>
              <div class="hard_content">{{ innerItem.content }}</div>
            </div>
          </div>
          <div class="hard_img" v-if="item.bgBlue">
            <img :src="item.image" alt="" />
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
    <!--  商铺智能硬件  -->
    <div v-else>
      <div v-for="item in merchantList" :key="item.id" :class="{ bg_blue: item.bgBlue }">
        <div class="hard_box">
          <div class="hard_img" v-if="!item.bgBlue">
            <img :src="item.image" alt="" />
            <span :class="{ title_white: item.title === '智能PDA' }">{{ item.title }}</span>
          </div>
          <div class="hard_con_box" :class="{ hard_con_box_right: item.bgBlue }">
            <div
              v-for="(innerItem, index) in item.list"
              :key="index"
              class="hard_content_box"
              :class="{
                con_white: item.bgBlue,
                content_7: item.list.length == 7,
                content_8: item.list.length == 8
              }"
            >
              <div class="hard_inner_img"><img :src="innerItem.image" alt="" /></div>
              <div class="hard_title">{{ innerItem.title }}</div>
              <div
                class="hard_content"
                :class="{ title_8: innerItem.title === '分离式设计' && item.list.length === 8 }"
              >
                {{ innerItem.content }}
              </div>
            </div>
          </div>
          <div class="hard_img" v-if="item.bgBlue">
            <img :src="item.image" alt="" />
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="app-main bg_blue">
      <div class="wholesale_programme_title1">
        <div class="wholesale_programme_title_text1">
          更多硬件产品
          <img src="../assets/img/title3@2x.png" alt="" />
        </div>
        <div class="zhexian"></div>
      </div>
      <div class="now_container">
        <div class="now_box" v-for="(item, i) in nowList" :key="i">
          <img :src="item.image" alt="" />
          <div class="now_title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-------------------------------------------- script -------------------------------------------->
<script>
export default {
  name: '',
  components: {},

  data() {
    return {
      active: 1,
      nowList: [
        { image: require('../assets/img/h-xx1.png'), title: '信息查询一体机' },
        { image: require('../assets/img/h-sc1.png'), title: '智能手持POS' },
        { image: require('../assets/img/h-led1.png'), title: 'LED大数据屏' },
        { image: require('../assets/img/h-kl1.png'), title: '客流采集仪' }
      ],
      menuList: [
        {
          title: '市场智能硬件',
          id: 1
        },
        {
          title: '商铺智能硬件',
          id: 2
        }
      ],
      marketList: [
        {
          image: require('../assets/img/h_pda.png'),
          bgBlue: false,
          id: 1,
          title: '智能PDA',
          list: [
            {
              image: require('../assets/img/pda-fh.png'),
              title: '防护升级',
              content: 'IP65三防设计，通过1.5M防跌落测试，康宁大猩猩触摸屏，增强抗摔性和耐划性'
            },
            {
              image: require('../assets/img/pda-wg.png'),
              title: '外观设计',
              content: '双按键设计，符合人体工程学且支持自定义，方便单手操作'
            },
            {
              image: require('../assets/img/pda-5000.png'),
              title: '5000mAh',
              content: 'ATL大容量电池，支持800次循环充放电'
            },
            {
              image: require('../assets/img/pda-zy.png'),
              title: '专业扫码头',
              content: '支持一维/二维条码识别，破损、褶皱、污渍遮挡条码均可识别'
            },
            {
              image: require('../assets/img/pda-yx.png'),
              title: '运行稳定流畅',
              content: '采用基于Android 9.0深度优化的系统软件兼容性更好，保障稳定流畅的使用'
            },
            {
              image: require('../assets/img/pda-4.png'),
              title: '4G/WiFi',
              content: '采用物联网通信与平台传输数据，设备部署简单，开机即可使用'
            }
          ]
        },
        {
          image: require('../assets/img/h_tc.png'),
          bgBlue: true,
          id: 2,
          title: '车辆进出场管理系统',
          list: [
            {
              image: require('../assets/img/tc-f.png'),
              title: '防作弊设计',
              content: '采用定制芯片及软件系统、开机自动置零、客显实时显示数据、设备拆机告警等'
            },
            {
              image: require('../assets/img/tc-fl.png'),
              title: '分离式设计',
              content:
                '基础计价秤与智能系统可以独立运行，支持电池供电的情况下基础计价秤工作24小时以上，智能系统运行8小时以上'
            },
            {
              image: require('../assets/img/tc-cz.png'),
              title: '操作简单',
              content: '不改变商户使用习惯，不增加商户操作，通过人工智能的技术进行数据采集'
            },
            {
              image: require('../assets/img/tc-jh.png'),
              title: '聚合支付',
              content: '提升交易支付的用户体验，支持多种支付方式和平台'
            },
            {
              image: require('../assets/img/tc-jxc.png'),
              title: '进销存管理',
              content: '为商户提供相应的管理功能，增加销售方式和途径'
            },
            {
              image: require('../assets/img/tc-cp.png'),
              title: '产品设计',
              content: '工业化设计、符合农贸市场特殊的环境应用'
            },
            {
              image: require('../assets/img/pda-4.png'),
              title: '4G移动网络',
              content: '采用物联网通信与平台传输数据，设备部署简单，开机即可使用'
            }
          ]
        },
        {
          image: require('../assets/img/h-sdb.png'),
          bgBlue: false,
          id: 3,
          title: '智能水电表',
          list: [
            {
              image: require('../assets/img/pda-fh.png'),
              title: '防护升级',
              content: 'IP65三防设计，通过1.5M防跌落测试，康宁大猩猩触摸屏，增强抗摔性和耐划性'
            },
            {
              image: require('../assets/img/pda-fh.png'),
              title: '外观设计',
              content: '双按键设计，符合人体工程学且支持自定义，方便单手操作'
            },
            {
              image: require('../assets/img/sdb-zx.png'),
              title: '在线提醒检修',
              content: 'ATL大容量电池，支持800次循环充放电'
            },
            {
              image: require('../assets/img/sdb-yc.png'),
              title: '远程智能抄表',
              content: '支持一维/二维条码识别，破损、褶皱、污渍遮挡条码均可识别'
            },
            {
              image: require('../assets/img/sdb-lh.png'),
              title: '远程拉合闸',
              content: '采用基于Android 9.0深度优化的系统软件兼容性更好，保障稳定流畅的使用'
            },
            {
              image: require('../assets/img/pda-4.png'),
              title: '4G/WiFi',
              content: '采用物联网通信与平台传输数据，设备部署简单，开机即可使用'
            }
          ]
        },
        {
          image: require('../assets/img/sb_1@2x.png'),
          bgBlue: true,
          id: 4,
          title: '语音播报打印机',
          list: [
            {
              image: require('../assets/img/tc-bb.png'),
              title: '播报清晰',
              content: 'IP65三防设计，通过1.5M防跌落测试，康宁大猩猩触摸屏，增强抗摔性和耐划性'
            },
            {
              image: require('../assets/img/pda-wg.png'),
              title: '外观设计',
              content: '双按键设计，符合人体工程学且支持自定义，方便单手操作'
            },
            {
              image: require('../assets/img/tc-kk.png'),
              title: '可靠性',
              content: '断网断电不用愁，订单自动补打，高效搭配助力经营'
            },
            {
              image: require('../assets/img/tc-cz.png'),
              title: '操作简单',
              content: '安装便捷，开机即可使用，操作简单安全'
            },
            {
              image: require('../assets/img/tc-jh1.png'),
              title: '聚合支付',
              content: '自带码牌、一机多用、收款打印播报三合一'
            },
            {
              image: require('../assets/img/pda-4.png'),
              title: '4G/WiFi',
              content: '采用物联网通信与平台传输数据，设备部署简单，开机即可使用'
            }
          ]
        },
        {
          image: require('../assets/img/h-dz1.png'),
          bgBlue: false,
          id: 1,
          title: '智能电子秤',
          list: [
            {
              image: require('../assets/img/tc-f.png'),
              title: '防作弊设计',
              content: '采用定制芯片及软件系统、开机自动置零、客显实时显示数据、设备拆机告警等'
            },
            {
              image: require('../assets/img/tc-fl.png'),
              title: '分离式设计',
              content: '可独立运行，支持电池供电的情况下基础计价秤工作24小时以上，智能系统运行8小时以上'
            },
            {
              image: require('../assets/img/sdb-lh.png'),
              title: '农产品溯源',
              content: '通过农批、农贸市场智能电子秤，做到农产品从生产到消费者的所有交易数据化'
            },
            {
              image: require('../assets/img/tc-cz.png'),
              title: '操作简单',
              content: '不改变商户使用习惯，不增加商户操作，通过人工智能的技术进行数据采集'
            },
            {
              image: require('../assets/img/tc-jh.png'),
              title: '聚合支付',
              content: '提升交易支付的用户体验，支持多种支付方式和平台'
            },
            {
              image: require('../assets/img/tc-jxc.png'),
              title: '进销存管理',
              content: '为商户提供相应的管理功能，增加销售方式和途径'
            },
            {
              image: require('../assets/img/tc-cp.png'),
              title: '产品设计',
              content: '工业化设计、符合农贸市场特殊的环境应用'
            },
            {
              image: require('../assets/img/pda-4.png'),
              title: '4G移动网络',
              content: '采用物联网通信与平台传输数据，设备部署简单，开机即可使用'
            }
          ]
        }
        // {
        //   image: require('../assets/img/h-kl.png'),
        //   bgBlue: true,
        //   id: 6,
        //   title: '客流采集仪',
        //   list: [
        //     {
        //       image: require('../assets/img/tc-f.png'),
        //       title: '防作弊设计',
        //       content: '采用定制芯片及软件系统、开机自动置零、客显实时显示数据、设备拆机告警等'
        //     },
        //     {
        //       image: require('../assets/img/tc-fl.png'),
        //       title: '分离式设计',
        //       content:
        //         '基础计价秤与智能系统可以独立运行，支持电池供电的情况下基础计价秤工作24小时以上，智能系统运行8小时以上'
        //     },
        //     {
        //       image: require('../assets/img/tc-cz.png'),
        //       title: '操作简单',
        //       content: '不改变商户使用习惯，不增加商户操作，通过人工智能的技术进行数据采集'
        //     },
        //     {
        //       image: require('../assets/img/tc-jh.png'),
        //       title: '聚合支付',
        //       content: '提升交易支付的用户体验，支持多种支付方式和平台'
        //     },
        //     {
        //       image: require('../assets/img/tc-jxc.png'),
        //       title: '进销存管理',
        //       content: '为商户提供相应的管理功能，增加销售方式和途径'
        //     },
        //     {
        //       image: require('../assets/img/tc-cp.png'),
        //       title: '产品设计',
        //       content: '工业化设计、符合农贸市场特殊的环境应用'
        //     },
        //     {
        //       image: require('../assets/img/pda-4.png'),
        //       title: '4G移动网络',
        //       content: '采用物联网通信与平台传输数据，设备部署简单，开机即可使用'
        //     }
        //   ]
        // },
        // {
        //   image: require('../assets/img/h-sp.png'),
        //   bgBlue: false,
        //   id: 7,
        //   title: '食品安全检测设备',
        //   list: [
        //     {
        //       image: require('../assets/img/tc-f.png'),
        //       title: '防作弊设计',
        //       content: '采用定制芯片及软件系统、开机自动置零、客显实时显示数据、设备拆机告警等'
        //     },
        //     {
        //       image: require('../assets/img/tc-fl.png'),
        //       title: '分离式设计',
        //       content:
        //         '基础计价秤与智能系统可以独立运行，支持电池供电的情况下基础计价秤工作24小时以上，智能系统运行8小时以上'
        //     },
        //     {
        //       image: require('../assets/img/tc-cz.png'),
        //       title: '操作简单',
        //       content: '不改变商户使用习惯，不增加商户操作，通过人工智能的技术进行数据采集'
        //     },
        //     {
        //       image: require('../assets/img/tc-jh.png'),
        //       title: '聚合支付',
        //       content: '提升交易支付的用户体验，支持多种支付方式和平台'
        //     },
        //     {
        //       image: require('../assets/img/tc-jxc.png'),
        //       title: '进销存管理',
        //       content: '为商户提供相应的管理功能，增加销售方式和途径'
        //     },
        //     {
        //       image: require('../assets/img/tc-cp.png'),
        //       title: '产品设计',
        //       content: '工业化设计、符合农贸市场特殊的环境应用'
        //     },
        //     {
        //       image: require('../assets/img/pda-4.png'),
        //       title: '4G移动网络',
        //       content: '采用物联网通信与平台传输数据，设备部署简单，开机即可使用'
        //     }
        //   ]
        // }
      ],
      merchantList: [
        {
          image: require('../assets/img/h-dz.png'),
          bgBlue: false,
          id: 1,
          title: '智能电子秤',
          list: [
            {
              image: require('../assets/img/tc-f.png'),
              title: '防作弊设计',
              content: '采用定制芯片及软件系统、开机自动置零、客显实时显示数据、设备拆机告警等'
            },
            {
              image: require('../assets/img/tc-fl.png'),
              title: '分离式设计',
              content: '可以独立运行，支持电池供电的情况下基础计价秤工作24小时以上，智能系统运行8小时以上'
            },
            {
              image: require('../assets/img/sdb-lh.png'),
              title: '农产品溯源',
              content: '通过农批、农贸市场智能电子秤，做到农产品从生产到消费者的所有交易数据化'
            },
            {
              image: require('../assets/img/tc-cz.png'),
              title: '操作简单',
              content: '不改变商户使用习惯，不增加商户操作，通过人工智能的技术进行数据采集'
            },
            {
              image: require('../assets/img/tc-jh.png'),
              title: '聚合支付',
              content: '提升交易支付的用户体验，支持多种支付方式和平台'
            },
            {
              image: require('../assets/img/tc-jxc.png'),
              title: '进销存管理',
              content: '为商户提供相应的管理功能，增加销售方式和途径'
            },
            {
              image: require('../assets/img/tc-cp.png'),
              title: '产品设计',
              content: '工业化设计、符合农贸市场特殊的环境应用'
            },
            {
              image: require('../assets/img/pda-4.png'),
              title: '4G移动网络',
              content: '采用物联网通信与平台传输数据，设备部署简单，开机即可使用'
            }
          ]
        },
        {
          image: require('../assets/img/h-sc.png'),
          bgBlue: true,
          id: 2,
          title: '智能手持POS',
          list: [
            {
              image: require('../assets/img/tc-f.png'),
              title: '防作弊设计',
              content: '采用定制芯片及软件系统、开机自动置零、客显实时显示数据、设备拆机告警等'
            },
            {
              image: require('../assets/img/tc-fl.png'),
              title: '分离式设计',
              content:
                '基础计价秤与智能系统可以独立运行，支持电池供电的情况下基础计价秤工作24小时以上，智能系统运行8小时以上'
            },
            {
              image: require('../assets/img/tc-cz.png'),
              title: '操作简单',
              content: '不改变商户使用习惯，不增加商户操作，通过人工智能的技术进行数据采集'
            },
            {
              image: require('../assets/img/tc-jh.png'),
              title: '聚合支付',
              content: '提升交易支付的用户体验，支持多种支付方式和平台'
            },
            {
              image: require('../assets/img/tc-jxc.png'),
              title: '进销存管理',
              content: '为商户提供相应的管理功能，增加销售方式和途径'
            },
            {
              image: require('../assets/img/tc-cp.png'),
              title: '产品设计',
              content: '工业化设计、符合农贸市场特殊的环境应用'
            },
            {
              image: require('../assets/img/pda-4.png'),
              title: '4G移动网络',
              content: '采用物联网通信与平台传输数据，设备部署简单，开机即可使用'
            }
          ]
        },
        {
          image: require('../assets/img/h_pda.png'),
          bgBlue: false,
          id: 3,
          title: '智能PDA',
          list: [
            {
              image: require('../assets/img/pda-fh.png'),
              title: '防护升级',
              content: 'IP65三防设计，通过1.5M防跌落测试，康宁大猩猩触摸屏，增强抗摔性和耐划性'
            },
            {
              image: require('../assets/img/pda-wg.png'),
              title: '外观设计',
              content: '双按键设计，符合人体工程学且支持自定义，方便单手操作'
            },
            {
              image: require('../assets/img/pda-5000.png'),
              title: '5000mAh',
              content: 'ATL大容量电池，支持800次循环充放电'
            },
            {
              image: require('../assets/img/pda-zy.png'),
              title: '专业扫码头',
              content: '支持一维/二维条码识别，破损、褶皱、污渍遮挡条码均可识别'
            },
            {
              image: require('../assets/img/pda-yx.png'),
              title: '运行稳定流畅',
              content: '采用基于Android 9.0深度优化的系统软件兼容性更好，保障稳定流畅的使用'
            },
            {
              image: require('../assets/img/pda-4.png'),
              title: '4G/WiFi',
              content: '采用物联网通信与平台传输数据，设备部署简单，开机即可使用'
            }
          ]
        },
        {
          image: require('../assets/img/sb_1@2x.png'),
          bgBlue: true,
          id: 4,
          title: '语音播报打印机',
          list: [
            {
              image: require('../assets/img/tc-bb.png'),
              title: '播报清晰',
              content: 'IP65三防设计，通过1.5M防跌落测试，康宁大猩猩触摸屏，增强抗摔性和耐划性'
            },
            {
              image: require('../assets/img/pda-wg.png'),
              title: '外观设计',
              content: '双按键设计，符合人体工程学且支持自定义，方便单手操作'
            },
            {
              image: require('../assets/img/tc-kk.png'),
              title: '可靠性',
              content: '断网断电不用愁，订单自动补打，高效搭配助力经营'
            },
            {
              image: require('../assets/img/tc-cz.png'),
              title: '操作简单',
              content: '安装便捷，开机即可使用，操作简单安全'
            },
            {
              image: require('../assets/img/tc-jh1.png'),
              title: '聚合支付',
              content: '自带码牌、一机多用、收款打印播报三合一'
            },
            {
              image: require('../assets/img/pda-4.png'),
              title: '4G/WiFi',
              content: '采用物联网通信与平台传输数据，设备部署简单，开机即可使用'
            }
          ]
        }
      ]
    }
  },

  /* 一.生命周期函数 */
  created() {},

  /* 二.监控函数 */
  watch: {},

  computed: {},

  /* 三.内部功能函数 */
  methods: {
    chooseMenu(item) {
      this.active = item.id
    }
  }
}
</script>

<!--------------------------------------------- style -------------------------------------------->
<style scoped>
.banner {
  height: 600px;
}

.banner1 {
  width: 100%;
  background: url('../assets/img/hardware1.png') no-repeat center center;
  background-size: cover;
  min-height: 600px;
  height: 550px;
}

.menu_box {
  width: 1200px;
  display: flex;
  justify-content: center;
  margin: 0 auto 60px;
}

.menu_con {
  width: 132px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #f7fbff;
  border-radius: 23px;
  border: 1px solid #1958c4;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1958c4;
}

.active_menu,
.menu_con:hover {
  width: 132px;
  height: 40px;
  line-height: 40px;
  background: #1958c4;
  border-radius: 23px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}

.menu_con:nth-child(1) {
  margin-right: 66px;
}

.bg_blue {
  width: 100%;
  background: #f7fbff;
}

.hard_box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0 8px;
  box-sizing: border-box;
}

.hard_img {
  position: relative;
}

.hard_img span {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 16px;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  width: 280px;
  text-align: center;
}

.title_white {
  color: #fff !important;
}

.hard_img img {
  width: 420px;
  height: 420px;
}

.hard_con_box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-left: 24px;
}

.hard_con_box_right {
  margin-left: 0;
  margin-right: 24px;
}

.hard_content_box {
  width: 244px;
  height: 204px;
  background: #f8f8f8;
  text-align: center;
  margin-bottom: 12px;
  padding: 20px 16px 0;
  box-sizing: border-box;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 23px;
}

.hard_inner_img img {
  width: 40px;
  height: 40px;
}

.hard_title {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  margin: 8px 0;
}

.hard_content {
  text-align: left;
}

.con_white {
  background: #ffffff;
}

.hard_con_box .content_7:nth-child(4),
.hard_con_box .content_7:nth-child(5),
.hard_con_box .content_7:nth-child(6),
.hard_con_box .content_7:nth-child(7) {
  width: 180px;
}

.content_8 {
  width: 180px;
  height: 204px;
  background: #f8f8f8;
}

.title_8 {
  width: 157px;
}

.wholesale_programme_title1 {
  width: 1200px;
  margin: 0 auto;
}

.wholesale_programme_title_text1 {
  width: 240px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  z-index: 99;
}

.wholesale_programme_title_text1 img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: 0px;
  z-index: -1;
}

.zhexian {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 16px;
}

.app-main {
  padding: 65px 0;
  margin: 0 auto;
}

.app-right img {
  width: 100%;
  height: 100%;
}

.left-item-img img {
  width: 50px;
  height: 50px;
}

.think_container img {
  width: 30px;
  height: 28px;
  margin-right: 10px;
}

.integration {
  background: none;
  padding-bottom: 0;
}

.integration_img {
  width: 1200px;
  height: 460px;
  margin: 0 auto;
}

.now_container {
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 50px auto 0;
  text-align: center;
}

.now_container img {
  width: 100%;
  height: 220px;
}

.now_title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #333333;
  margin: 10px 0 19px;
}

.now_container p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.now_box {
  width: 282px;
  height: 282px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  flex-wrap: wrap;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
}
.now_box:hover{
  box-shadow:0px 5px 20px 0px rgba(0, 0, 0, 0.07);
}
</style>
